import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import {
  AuthService,
  UserAccess,
  UserRoles,
} from '../../../services/auth.service';
import { User, UserService } from '../../../services/user.service';

@Component({
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrl: './user-dialog.component.scss',
})
export class UserDialogComponent {
  @Input() data: User | undefined = undefined;

  form: FormGroup;

  constructor(
    protected dialogRef: NbDialogRef<UserDialogComponent>,
    protected userService: UserService,
    protected authService: AuthService,
    protected fb: FormBuilder
  ) {
    this.form = this.fb.group({
      name: '',
      email: '',
      role: '',
    });
  }

  ngOnInit(): void {
    if (this.data) {
      this.form.patchValue({
        ...this.data,
      });
    }
  }

  async onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    await this.userService
      .updateUser({
        ...this.data,
        ...(this.form.value as any),
      })
      .subscribe(() => {
        this.dialogRef.close();
      });
  }

  showInputError(name: string) {
    return this.form.get(name)?.touched && this.form.get(name)?.invalid;
  }

  get roles() {
    if (!this.authService.hasAccess(UserAccess.UserDialogSuperAdminRole)) {
      return Object.values(UserRoles).filter(
        (role) => role !== UserRoles.SuperAdmin
      );
    }

    return Object.values(UserRoles);
  }
}
